// extracted by mini-css-extract-plugin
export var discard = "_2f-3";
export var muiTooltipTooltip = "_2f-5";
export var notificationBar = "_2f-2";
export var saveButtonHoverSlotWrapper = "_2f-4";
export var show = "_2f-1";
export var spacer = "_2f-0";